import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-okey',
  templateUrl: './email-sent 1.svg',
})
export class OkeyComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
